<template>
  <div class="live-menu">
    <active-button
      v-for="sport in sports"
      :key="sport.id"
      line-color="blue"
      :active="( !$route.params.sport && sport.id == 2 ) || $route.params.sport == sport.id"
      :title="sport.name"
      @click="$router.push(`/home/live/sport/${sport.id}`)"
      class="menu-item"
    >
      <sport-icon-liga-white :name="sport.alias" style="margin-top: -5px;"></sport-icon-liga-white>
      <span class="count-events">{{ sport.events.length }}</span>
      <span>{{ sport.name }}</span>
    </active-button>
  </div>
</template>

<script>
import ActiveButton from '@/components/buttons/ActiveButton'
import SportIconLigaWhite from '@/components/icons/SportIconLigaWhite'
import { mapState } from 'vuex'

export default {
  components: {
    ActiveButton,
    SportIconLigaWhite
  },
  computed: {
    ...mapState({
      sports: state => state.live.menu
    })
  },
  data () {
    return {
      updateInterval: null
    }
  },
  mounted () {
    const dispatchGetting = () => {
      this.$store.dispatch('live/GET_MENU_SPORTS')
    }
    dispatchGetting()
    this.updateInterval = setInterval(function () {
      dispatchGetting()
    }, 2000)
  },
  beforeDestroy () {
    clearInterval(this.updateInterval)
  }
}
</script>

<style scoped>
.live-menu { display: flex; /* width: 500px !important; */ }
.menu-item { align-items: center; height: 50px; display: flex; flex-direction: column; flex-shrink: 0; justify-content: center; padding: 0 10px; flex: 1; }
.menu-item .sport-icon-liga-white { margin: 3px 0; }
.count-events { z-index: 1;
    margin-top: -30px;
    position: absolute;
    margin-left: 36px;
    font-weight: 700;
    font-size: 12px; }
</style>



// WEBPACK FOOTER //
// src/components/sports/main/live/Menu.vue